'use client';

import { useState, useEffect } from 'react';
import ProcessStep from './ProcessStep';

interface ProcessFlowProps {
  steps: Array<{
    number: number;
    title: string;
    description: string;
    details: string[];
    icon: string;
    example: string;
  }>;
}

export default function ProcessFlow({ steps }: ProcessFlowProps) {
  const [activeStep, setActiveStep] = useState(1);
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  useEffect(() => {
    if (!isHydrated) return;

    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight / 2;
      const stepElements = document.querySelectorAll('[data-step]');
      
      stepElements.forEach((element) => {
        const rect = element.getBoundingClientRect();
        const elementTop = rect.top + window.scrollY;
        const elementBottom = elementTop + rect.height;
        
        if (scrollPosition >= elementTop && scrollPosition <= elementBottom) {
          const stepNumber = parseInt(element.getAttribute('data-step') || '1');
          setActiveStep(stepNumber);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHydrated]);

  return (
    <div data-component-id="src/app/the-vibe-loop-methodology/components/ProcessFlow.tsx:49:4" data-component-path="src/app/the-vibe-loop-methodology/components/ProcessFlow.tsx" data-component-line="49" data-component-file="ProcessFlow.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%22%7D" className="relative">
      <div data-component-id="src/app/the-vibe-loop-methodology/components/ProcessFlow.tsx:50:6" data-component-path="src/app/the-vibe-loop-methodology/components/ProcessFlow.tsx" data-component-line="50" data-component-file="ProcessFlow.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20left-8%20md%3Aleft-12%20top-0%20bottom-0%20w-0.5%20bg-gradient-to-b%20from-primary%20via-secondary%20to-primary%20opacity-30%22%7D" className="absolute left-8 md:left-12 top-0 bottom-0 w-0.5 bg-gradient-to-b from-primary via-secondary to-primary opacity-30"></div>
      
      <div data-component-id="src/app/the-vibe-loop-methodology/components/ProcessFlow.tsx:52:6" data-component-path="src/app/the-vibe-loop-methodology/components/ProcessFlow.tsx" data-component-line="52" data-component-file="ProcessFlow.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-8%22%7D" className="space-y-8">
        {steps.map((step) => (
          <div data-component-id="src/app/the-vibe-loop-methodology/components/ProcessFlow.tsx:54:10" data-component-path="src/app/the-vibe-loop-methodology/components/ProcessFlow.tsx" data-component-line="54" data-component-file="ProcessFlow.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" key={step.number} data-step={step.number}>
            <ProcessStep data-component-id="src/app/the-vibe-loop-methodology/components/ProcessFlow.tsx:55:12" data-component-path="src/app/the-vibe-loop-methodology/components/ProcessFlow.tsx" data-component-line="55" data-component-file="ProcessFlow.tsx" data-component-name="ProcessStep" data-component-content="%7B%22elementName%22%3A%22ProcessStep%22%7D" step={step} isActive={activeStep === step.number} />
          </div>
        ))}
      </div>
    </div>
  );
}